/*
创建者 魏强(2018.3.8)
自营商城 还没逛够
*/
<template>
  <div class="mod-selling orange">
    <h3 class="mod-selling-title">
      <span>还没逛够</span>
    </h3>
    <div class="module-goods">
      <ul
        class="clearfix"
        id="hmggDiv"
      >
        <li
          v-for="item in data"
          :key="item.goodsId"
        >
          <router-link
            :to="{path:'/goods',query:{goods_id:item.goodsId}}"
            target="_blank"
          >
            <div class="img">
              <img
                :src="item.designImage"
                style="cursor: pointer;"
              />
            </div>
            <div class="tit">{{item.name}}</div>
            <div class="pri">&yen; &nbsp; {{item.price}}</div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
  mounted() {
    console.log(this.data, '99999999')
  },
};
</script>



// WEBPACK FOOTER //
// not-enough.vue?6259727c